<template>
	<div class="zhuiSu">
	
	  <div class="nandian">
	    <div>
	      <p>
	        日前，打着区块链旗号、具有存币生息，自称本金能随进随出的理财钱包TokenStore疑似跑路，项目官网无法访问、APP无法操作，数万受害者的数十亿资金无法取出。此案具有较强的典型性，涉及资金规模巨大，受害人员众多，波及范围广，影响恶劣。如何有效遏制跑路事件，减少投资人损失，维护资产安全。是急待解决对的问题。
	      </p>
	      <img src="../../images/zhuisu_img.jpg">
	    </div>
	  </div>
	
	  <div class="fangan">
	    <div>
	      中经天平司法鉴定中心从强化证据效力、能通过合法渠道进行法律维权、挽回资产损失。面向社会推出了数字资产追溯服务，通过一个数字资产地址，即可获得与之相关的行为分析鉴定报告。
	    </div>
	  </div>
	</div>
</template>

<script>
	import axios from 'axios'
	import '../assets/css/zhuiSu.less'
	export default {
		name: 'index',
		data() {
			return {
				
			}
		},
		methods: {
			
		},
		components: {
			
		},
		computed: {},
		watch: {
		},
		created() {
		}
	};
</script>

<style lang="less">
	
</style>
